import React, { useState } from 'react'
import { HMapPanels } from '../const/HMapPanels'
import { HMapOperations } from '../const/HMapOperations'
import { useHMapContext } from '../hooks/useHMapContext'
import HMapDetailsPanel from './detailsPanel/HMapDetailsPanel'
import HMapDisplayPanel from './displayPanel/HMapDisplayPanel'
import HMapDetailsNewPanel from './detailsPanel/HMapDetailsNewPanel'
import HMapLeftPanelContainer from './layout/HMapLeftPanelContainer'
import HMapDetailsEditPanel from './detailsPanel/HMapDetailsEditPanel'
import HMapInstructionPanel from './instructionPanel/HMapInstructionPanel'

const {
  HMapInstruction,
  HMapDisplay,
  HMapDetailsNew,
  HMapDetailsEdit,
  HMapDetailsReadOnly
} = HMapPanels
const { NewRecord, EditRecord, ReadOnlyRecord } = HMapOperations

const getPanel = (currentPanel, inputprops) => {
  const panels = {
    [HMapInstruction]: <HMapInstructionPanel {...inputprops} />,
    [HMapDisplay]: <HMapDisplayPanel {...inputprops} />,
    [HMapDetailsNew]: <HMapDetailsNewPanel {...inputprops} />,
    [HMapDetailsEdit]: <HMapDetailsEditPanel {...inputprops} />,
    [HMapDetailsReadOnly]: <HMapDetailsPanel {...inputprops} />
  }

  return panels[currentPanel] || <></>
}

const HMapLeftPanel = ({ open, setOpen }) => {
  const { dontShowInstructionConfig } = useHMapContext()
  const [dontShowInstructionRef,] = dontShowInstructionConfig
  const panelToDisplay = !!dontShowInstructionRef.current
    ? HMapDisplay
    : HMapInstruction
  const [currentPanel, setCurrentPanel] = useState(panelToDisplay)

  const getComponentProps = () => ({
    ...{ setCurrentPanel },
    ...(currentPanel === HMapDetailsNew && {
      operation: NewRecord
    }),
    ...(currentPanel === HMapDetailsEdit && {
      operation: EditRecord
    }),
    ...(currentPanel === HMapDetailsReadOnly && {
      operation: ReadOnlyRecord
    })
  })

  return (
    <>
      <HMapLeftPanelContainer toggle={open} setToggle={setOpen}>
        {getPanel(currentPanel, getComponentProps())}
      </HMapLeftPanelContainer>
    </>
  )
}

export default React.memo(HMapLeftPanel)
